import {DialogFragment, PageFragment, PageFragmentProps} from "@/shared/PageFragment";
import {Box} from "@mui/material";
import {FormGenContainer, FormGenContainerMode} from "@/shared/FormGenContainer";
import {DW_LG} from "@/shared/dimens";
import {BaseApp, DIALOG_FLAG_DISABLE_BACKDROP_CLICK, DIALOG_FLAG_SHOW_CLOSE} from "@/shared/BaseApp";
import React from "react";
import {LabelerImport, LabelerImports, ResourceData} from "@/fyneai-shared/types";

export class EditImportHelper {

  static addImport(datasetId: string) {
    BaseApp.CONTEXT.showDialog(
      {flags: DIALOG_FLAG_SHOW_CLOSE | DIALOG_FLAG_DISABLE_BACKDROP_CLICK},
      () => <EditLabelerImportFragment datasetId={datasetId}
                                       onLabelerImportSaved={item => BaseApp.CONTEXT.hideDialog()}/>);
  }

  static editImport(datasetId: string, item: LabelerImport) {
    BaseApp.CONTEXT.showDialog(
      {flags: DIALOG_FLAG_SHOW_CLOSE | DIALOG_FLAG_DISABLE_BACKDROP_CLICK},
      () => <EditLabelerImportFragment datasetId={datasetId} edit={item}
                                       onLabelerImportSaved={item => BaseApp.CONTEXT.hideDialog()}/>);
  }
}

type EditLabelerImportFragmentProps = PageFragmentProps & {
  datasetId: string,
  edit?: LabelerImport,
  onLabelerImportSaved: (item: LabelerImport) => void,
}

class EditLabelerImportFragment extends DialogFragment<EditLabelerImportFragmentProps> {

  private readonly labelerImports = new LabelerImports(ResourceData.projectId(), this.props.datasetId);
  private readonly labelerImport = this.props.edit ? this.props.edit : LabelerImport.createNew();

  protected onCreateState() {
    return {
      ...super.onCreateState(),
      title: this.props.edit ? "Edit import" : "Add import",
    };
  }

  protected styleFlags(): number {
    return PageFragment.STYLE_ACTION_PANEL_TYPE_BUTTON_FLAG;
  }

  protected getActionButtonText(): string {
    return this.props.edit ? "Save" : "Add";
  }

  onActionButtonClicked() {
    this.saveLabelerImport().then(() => this.props.onLabelerImportSaved(this.labelerImport));
  }

  private async saveLabelerImport() {
    await this.labelerImports.addListItem(this.labelerImport);
  }

  renderContent(): React.ReactElement | null {
    return <Box style={{display: "flex", width: DW_LG}}>
      <FormGenContainer
        mode={this.props.edit ? FormGenContainerMode.EDIT : FormGenContainerMode.CREATE}
        content={this.labelerImport}
        saveActionButtonProvider={this}/>
    </Box>;
  }
}
